import { ReactNode } from 'react';
import { UI } from '@/Components/UI';
import { useTranslation } from 'react-i18next';

type FilterModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onApply: () => void;
    children: ReactNode;
}

export const FilterDialog = ({ isOpen, onClose, onApply, children }: FilterModalProps)=> {
    const { t } = useTranslation(['misc']);

    function Footer() {
        return (
            <div className={'flex flex-row justify-end gap-2 w-full'}>
                <UI.Button
                    buttonStyle={'text'}
                    onClick={onClose}>
                    {t('cancel')}
                </UI.Button>

                <UI.Button
                    onClick={onApply}>
                    {t('apply')}
                </UI.Button>
            </div>
        );
    }

    return (
        <UI.Dialog
            hideHeader={true}
            isOpen={isOpen}
            onClose={onClose}
            footer={Footer()}>
            {children}
        </UI.Dialog>
    );
}
